<template>
    <div class="h-full">
        <div class="flex justify-between items-center px-4 py-3">
            <span class="font-semibold text-lg">
                {{ pageMeta?.pageTitle }}
            </span>

            <ProfileDropdown
                :authUser="authUser"
                :authCompanyUser="authCompanyUser"
                :impersonating="impersonating"
                class="hidden md:block"
            />
        </div>
        <div class="px-4">
            <div class="border-b border-stone-200"></div>
        </div>
        <div class="p-4 space-y-4">
            <div
                v-if="slots.left || slots.right"
                class="flex justify-between items-center gap-2"
            >
                <div v-if="slots.left">
                    <slot name="left" />
                </div>
                <div v-else></div>

                <div v-if="slots.right">
                    <slot name="right" />
                </div>
                <div v-else></div>
            </div>
            <div>
                <slot />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useSlots } from 'vue'
    import ProfileDropdown from '@/Shared/Component/ProfileDropdown.vue'
    import type { PageMeta } from '@/Shared/AutoGenerated/Main'
    import User from '@/App/User/Entity/User'
    import CompanyUser from '@/App/CompanyUser/Entity/CompanyUser'

    interface PageWrapperProps {
        pageMeta: PageMeta
        authUser: User
        authCompanyUser: CompanyUser
        impersonating: boolean
    }

    const props = defineProps<PageWrapperProps>()
    const slots: any = useSlots()
</script>
